module.exports = __webpack_public_path__ + "static/media/link_has_expired.bce8ffeb.svg";